module.exports = __webpack_public_path__ + "img/1.456813e6.jpg";